<template>
    <v-dialog
      v-model="dialog"
      width="900"    
      persistent
    >              
    <!-- Form Start -->
    <v-card color="white">
        <!-- Form Caption -->        
        <v-card-title>           
            <h3 class="display-2">{{attributes.hint}}</h3> </br>            
            <!-- <code>{{result}}</code>  -->
            <!--<code>{{recipesteps}}</code> -->
        </v-card-title>
        <!-- Main Container-->
        <v-card-text>
            <v-container fluid grid-list-md>
                <v-layout row wrap>
                    <!-- First Box/ Save Box -->                                  
                    <v-flex d-flex xs12>
                        <form-search-bar 
                            v-on:resultChange="onResultChange" 
                            v-on:searchCanceled="onSearchCanceled"
                            :lists="attributes.lists"
                            :listitems="attributes.items"
                            >
                        </form-search-bar>
                    </v-flex>
                    <v-flex d-flex xs12>                                               
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>        
    <!-- Form End -->
    </v-card>
    </v-dialog>
</template>
<script>
    import { mapGetters } from 'vuex';
    import FormSearchBar from './FormSearchBar.vue'
    
    export default { 
    name: "mainform",
    components: {
        'form-search-bar':FormSearchBar,        
    },
    props:[        
        'dialog',
        'itemid',   
        'attributes'
    ],
    
    data() {
        return {                   
            formdata: {
                color:"black",
                name:"Test"
            },            
            //result:null
            
        }
    },
   computed: {
 
    },
    watch:{
       
    },
    methods: {
        onResultChange(item) {            
            //this.result = item
            this.$emit('input',item)
            this.$emit('closeDialog')            
        },
        onSearchCanceled() {
            this.$emit('closeDialog')
        }
        
    },    
    

   
                 
        
}
</script>